<template>
    <b-modal id="my-modal" scrollable 
        :no-close-on-backdrop=true 
        :title="label" 
        :no-close-on-esc=true 
        v-model="isShowPopup" 
        ok-title="Ok" 
        ok-variant="success" 
        size="sm"
        @hidden="resetModal"
    >

    <div>
      <b-card no-body>
        <b-tabs card content-class="mt-3">
          <b-tab title="Approval Log" active>
            <b-card no-body class="mt-3" v-for="item in model" v-bind:key="item.id">
              <b-card-header header-tag="header" role="tab" class="p-2 pl-3" style="border-left: solid 4px #7d8492">
                  <b-row>
                    <b-col cols="12">
                        <div class="text-dark pt-lg-1">
                            {{ item.logDate | moment("DD-MMM-YYYY HH:mm") }}
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div>
                            <h5 class="font-weight-bold mb-0 mb-lg-1">
                                {{ item.actionUser }}
                            </h5>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div>
                            <h6 class="font-weight mb-0 mb-lg-1">
                                {{ item.actionTaken }}
                            </h6>
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <div class="text-secondary">
                          <b-form-group id="fieldset-survey-main-customer" label-cols-sm="12" label-cols-lg="12" label="Notes" label-for="filter-survey-main-customer">
                            {{ item.message != null && item.message != '' ? item.message : "-" }}
                          </b-form-group>
                        </div>
                    </b-col>
                </b-row>
              </b-card-header>
            </b-card>
          </b-tab>
          <b-tab title="Approval Flow">
            <div class="table-corner mb-3" v-for="item in modelFlow" v-bind:key="item.id">
                <b-card no-body>
                    <b-card-header header-tag="header" role="tab" class="p-0" style="border-left: solid 4px #007bff">
                        <b-button v-b-toggle="'inbox-' + item.id" class="filter" variant="white" block href="#">
                            <b-row class="mt-2">
                                <b-col cols="10" lg="11">
                                    <b-row>
                                        <b-col cols="12" lg="1">
                                            <b-icon-person-fill class="d-none d-lg-block ml-lg-2"></b-icon-person-fill>
                                        </b-col>
                                        <b-col cols="12" lg="6">
                                            <div>
                                              
                                                <h6 class="font-weight-bold mb-0">{{ item.approverName != null && item.approverName != undefined && item.approverName != "" ? item.approverName : "Originator" }}</h6>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" lg="2">
                                            <b-badge v-if="item.approverName != null && item.approverName != undefined && item.approverName != ''" variant="primary">{{ item.approverCount }} Approver{{ item.approverCount > 1 ? 's' : '' }}</b-badge>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="2" lg="1">
                                    <span class="d-lg-none d-block">
                                        <b-icon-chevron-up style="margin-top:40px;margin-right:-10px" class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down style="margin-top:40px;margin-right:-10px" class="float-right chevron-down"></b-icon-chevron-down>
                                    </span>
                                    <span class="d-none d-lg-block">
                                        <b-icon-chevron-up class="float-right chevron-right"></b-icon-chevron-up><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
                                    </span>
                                </b-col>
                            </b-row>
                        </b-button>
                    </b-card-header>
                    <b-collapse :id="'inbox-' + item.id" role="tabpanel" :visible="item.isActive ? true : false">
                        <b-card-body>
                            <b-row>
                                <b-col cols="12">
                                    <b-table-simple>
                                      <b-tbody>
                                          <b-tr v-for="itemDetail in item.approvalFlowDetails" :key="itemDetail.id">
                                            <b-td class="text-center">{{ itemDetail.approverName }}</b-td>
                                            <b-td class="text-center">{{ itemDetail.approverStatus }}</b-td>
                                          </b-tr>
                                      </b-tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    
    <template #modal-footer="{ ok }">
      <b-button size="sm" variant="secondary" class="float-right mr-2" @click="ok()">Close</b-button>
    </template>
    </b-modal>
</template>
<style lang="scss" scoped>
	.p-value {
        padding-top: calc(0.375rem + 1px);
        padding-bottom: calc(0.375rem + 1px);
    }
    .btn.not-collapsed .chevron-down {
        display: inline;
    }

    .btn.not-collapsed .chevron-right {
        display: none;
    }

    .btn.collapsed .chevron-right {
        display: inline;
    }

    .btn.collapsed .chevron-down {
        display: none;
    }
</style>
<script>
export default {
    props: ["openPopup","label","resetModalMethod", "contentLabel","approvalInstanceId"],
    data() {
      return {
        progressInterval : null,
        isBusy : false,
        isSuccess : false,
        isFailed : false,
        dataUrl : "",
        fileName : "",
        model: [],
        modelFlow: [],
      };
    },
    computed: {
        isShowPopup : {
            get: function () {
              if (this.openPopup) {
                this.getApprovalHistory();
                this.getApprovalFlow();
                return true;
              }
              else return false;
            },
            set: function (newValue) {}
          }
    },
    async mounted() {
    },
    watch : {
    },
    methods: {
        resetModal() {
          this.isShowPopup = false;
          this.$emit('resetModalMethod');
        },
        getApprovalHistory() {
          if (this.approvalInstanceId == null || this.approvalInstanceId == undefined) return;
          this.isBusy = true;
          this.$http.get(process.env.VUE_APP_API_URL + 'home/approvalhistory/' + this.approvalInstanceId)
          .then(response => {
            console.log(response);
            if (response.data != null) {
              this.model = response.data;
            } else {
              this.isBusy = false;
            }
          }).catch(error => {
            this.isBusy = false;
          })
        },
        getApprovalFlow() {
          if (this.approvalInstanceId == null || this.approvalInstanceId == undefined) return;
          this.isBusy = true;
          this.$http.get(process.env.VUE_APP_API_URL + 'approvalflow/' + this.approvalInstanceId)
          .then(response => {
            console.log(response);
            if (response.data != null) {
              this.modelFlow = response.data;
            } else {
              this.isBusy = false;
            }
          }).catch(error => {
            this.isBusy = false;
          })
        },
    }
}
</script>